module.exports = __webpack_public_path__ + "img/overlay-background.eeda8f72.png";